<template>
    <div>
        <NewAuctionCard />
    </div>
</template>

<script>
import NewAuctionCard from "../components/NewAuctionCard.vue";
export default {
    name: "NewAuction",
    components: { NewAuctionCard },
};
</script>
